var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 94,
    viewBox: "0 0 106 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.853C0 59.7005 12.2308 63 25.2769 63H88.0615C94.041 63 106 59.7005 106 46.5025C106 33.3045 94.041 28.3554 88.0615 27.5306C88.6051 25.0561 87.7354 18.4571 79.9077 11.8582C72.08 5.25931 61.4256 8.00899 57.0769 10.2087C52.7282 4.98456 40.7692 -3.97897 27.7231 1.96005C14.6769 7.89908 13.0462 20.382 13.8615 25.8811C9.24103 27.2559 0 32.9749 0 44.853Z",
    fill: "#C4E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32H67.979L77 40.3891V94H29V32Z",
    fill: "#F1F5FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81.4443H61.4443V77H57V81.4443ZM58.1111 78.1111H60.3332V80.3332H58.1111V78.1111Z",
    fill: "#BFD4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86.9999H61.4443V82.5557H57V86.9999ZM58.1111 83.6667H60.3332V85.8889H58.1111V83.6667Z",
    fill: "#BFD4F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5557 77V81.4443H66.9999V77H62.5557ZM65.8889 80.3332H63.6667V78.1111H65.8889V80.3332Z",
    fill: "#BFD4F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9997 85.8887H65.8887V86.9997H66.9997V85.8887Z",
    fill: "#BFD4F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6667 82.5557H62.5557V83.6667H63.6667V82.5557Z",
    fill: "#BFD4F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7776 83.666H63.6665V84.7771H64.7776V83.666Z",
    fill: "#BFD4F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6667 84.7773H62.5557V85.8884H63.6667V84.7773Z",
    fill: "#BFD4F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7776 85.8887H63.6665V86.9997H64.7776V85.8887Z",
    fill: "#BFD4F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8889 84.7773H64.7778V85.8884H65.8889V84.7773Z",
    fill: "#BFD4F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8889 82.5557H64.7778V83.6667H65.8889V82.5557Z",
    fill: "#BFD4F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9997 83.666H65.8887V84.7771H66.9997V83.666Z",
    fill: "#BFD4F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40.3975L68 40.3975L68 32L77 40.3975Z",
    fill: "#BFD4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 59.8965,
    width: 28,
    height: 2.13793,
    fill: "#BFD4F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 65.2412,
    width: 28,
    height: 2.13793,
    fill: "#BFD4F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 70.5859,
    width: 28,
    height: 2.13793,
    fill: "#BFD4F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.167c186c7f68ec6cf518c5eeb88c973b.svg";
export { ForwardRef as ReactComponent };